module.exports = __webpack_public_path__ + "assets/img/URLicon.e4794922.svg";